// Captures the browser's beforeinstallprompt so we can trigger the native
// "Add to Home Screen" dialog later — Chrome/Edge/Samsung on Android fire
// this event once, and if we don't stash it we can never call prompt().
// iOS Safari doesn't fire the event, so isInstallable() returns false there
// and callers should show a manual "tap Share → Add to Home Screen" tutorial.

let deferredPrompt = null;
let outcomeListeners = [];

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
  });
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    outcomeListeners.forEach(fn => { try { fn('installed'); } catch { /* ignore */ } });
    outcomeListeners = [];
    try { localStorage.setItem('cuminjar_pwa_installed', '1'); } catch { /* ignore */ }
  });
}

export function isInstallable() {
  return !!deferredPrompt;
}

export function isStandalone() {
  if (typeof window === 'undefined') return false;
  return (
    (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) ||
    window.navigator.standalone === true
  );
}

export function isIOS() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  return /iPhone|iPad|iPod/i.test(ua) && !window.MSStream;
}

export function isAndroid() {
  if (typeof navigator === 'undefined') return false;
  return /Android/i.test(navigator.userAgent || '');
}

export function isMobile() {
  if (typeof window === 'undefined') return false;
  return isIOS() || isAndroid() || window.matchMedia('(max-width: 900px)').matches;
}

export async function promptInstall() {
  if (!deferredPrompt) return 'unavailable';
  try {
    deferredPrompt.prompt();
    const choice = await deferredPrompt.userChoice;
    deferredPrompt = null;
    return choice.outcome; // 'accepted' | 'dismissed'
  } catch {
    return 'error';
  }
}

const DISMISS_KEY = 'cuminjar_pwa_nudge_dismissed';

export function wasNudgeDismissed() {
  try { return localStorage.getItem(DISMISS_KEY) === '1'; } catch { return false; }
}

export function markNudgeDismissed() {
  try { localStorage.setItem(DISMISS_KEY, '1'); } catch { /* ignore */ }
}

export function shouldShowNudge() {
  // Skip when already installed, in-app, on desktop, or previously dismissed.
  if (isStandalone()) return false;
  if (!isMobile()) return false;
  if (wasNudgeDismissed()) return false;
  // Any mobile visitor gets the offer — even before beforeinstallprompt has
  // fired, we can still show a manual "menu → Add to Home Screen" tutorial
  // (browsers vary a lot on when they fire the event, some never do).
  return true;
}
